export default "__VITE_ASSET__ZpIk8ghh__"